<script setup lang="ts">
    import AppModalContent from '@/components/modal/AppModalContent.vue';
    import { usePlanDownloadWarningViewModel } from '@/views/plan/usePlanDownloadWarningViewModel';

    const props = defineProps<{ value: boolean }>();
    const emit = defineEmits(['submit', 'close']);
    // Destructured so the template binds the values rather than the refs: a plain composable
    // returns raw refs, which Vue does not auto-unwrap through an object, but does unwrap as
    // top-level bindings of `<script setup>`.
    const { canCreatePlan, actLabel, plannerPath } = usePlanDownloadWarningViewModel();
</script>

<template>
    <app-modal :model-value="props.value" persistent max-width="700">
        <v-card class="no-shadow">
            <app-modal-title @close="emit('close')">
                <v-icon color="planner-orange" size="40" class="ml-0 ma-2">
                    mdi-alert-outline
                </v-icon>
                Download this Plan?
            </app-modal-title>

            <app-modal-content>
                <p>Changes have been made in the 3D planner since this plan was produced.</p>

                <p v-if="canCreatePlan">
                    If you need to produce a new plan including these changes, please
                    <router-link :to="plannerPath" class="text-decoration-none text-success">
                        return to the 3D planner
                    </router-link>
                    and click <b>&rsquo;{{ actLabel }}&rsquo;</b>, otherwise, click
                    <b>&rsquo;Download this Plan&rsquo;</b> below to continue.
                </p>

                <p v-else>
                    Please contact a user with the ability to create a new plan for this case,
                    otherwise, click
                    <b>&rsquo;Download this Plan&rsquo;</b> below to continue.
                </p>
            </app-modal-content>

            <app-modal-actions>
                <app-button-secondary width="100" class="mr-5" @click="emit('close')">
                    Close
                </app-button-secondary>

                <router-link v-if="canCreatePlan" :to="plannerPath" class="text-decoration-none">
                    <app-button-primary class="text-uppercase mx-2" text>
                        Return to 3D Planner
                    </app-button-primary>
                </router-link>

                <v-spacer />

                <app-button-primary @click="emit('submit')">
                    Download this plan
                </app-button-primary>
            </app-modal-actions>
        </v-card>
    </app-modal>
</template>
